var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.fullViewportWidthWrapper ? _vm.elementClass : 'container'},[(!_vm.fullViewportWidthWrapper)?_c('div',{class:_vm.elementClass},[_vm._t("default")],2):_c('div',{class:_vm.innerContainerClass},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }